import React from "react";
import { Helmet } from "react-helmet";
import "../../../App.css";
import featuredImage from "../../../assets/MurderMysterMagic.png";
import titleImage from "../../../assets/TitleMMM.png";

const Home = () => {
    const baseURL = window.location.origin; // This automatically changes for localhost and production

    return (
        <div className="home-container">

            {/* SEO Meta Tags for Social Media Sharing */}
            <Helmet>
                <title>Pogforts - MMM Discord Server</title>
                <meta name="description" content="Join Pogforts for an immersive Murder Mystery Magic game experience on Discord!" />
                <meta property="og:title" content="Pogforts - A Magical Discord Game" />
                <meta property="og:description" content="Experience a Discord server game like never before! Join Pogforts for the ultimate magic adventure." />
                <meta property="og:image" content={`${baseURL}/assets/PogfortsHome.png`} />
                <meta property="og:url" content={`${baseURL}/home`} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Pogforts - A Magical Discord Game" />
                <meta name="twitter:description" content="Join Pogforts for an immersive Murder Mystery Magic game experience on Discord!" />
                <meta name="twitter:image" content={`${baseURL}/assets/PogfortsHome.png`} />
            </Helmet>

            {/* Hidden H1 Title for SEO but invisible to users */}
            <h1 className="hidden-title">Welcome to Pogforts</h1>

            <img src={titleImage} alt="TitleMMM" className="featured-image" />
            
            {/* Featured Image Below Title */}
            <img src={featuredImage} alt="Pogforts" className="featured-image" />

            <p>Welcome to Pogforts!</p>
        </div>
    );
};

export default Home;

